<script setup>
import { onMounted, ref, onUnmounted  } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { Toast, Loading } from 'vant'
import { getPayOrder, payOrder } from '@/api/pay'
import { isWeixinBrowser, isInApp } from '@/utils/tools'
import { PAY_ORIGIN_SYSTEM_ID } from '@/constants'
import { WebBridgeApi } from 'ijsbridge'

const emit = defineEmits(['payFinish'])

const route = useRoute()
const store = useStore()

const showWxMiniProgram = ref(false)
const timer = ref(null)
const orderSn = route.query.orderSn

const loading = ref(false)

// 轮询，查询订单状态
async function pollOrderStatus() {
  if (!isInApp() && loading.value) return

  clearInterval(timer.value)

  !isInApp() && (loading.value = true)
  let duration = 0
  timer.value = setInterval(async () => {
    duration += 1000
    const res = await getPayOrder({
      orderSn,
      originSystemId: PAY_ORIGIN_SYSTEM_ID,
      token: store.getters.getToken
    })
    if (res.code == 1) {
      const orderStatus = res.data.orderStatus
      if (orderStatus === 2) {
        clearInterval(timer.value)
        Toast('支付完成')
        showWxMiniProgram.value = false
        loading.value = false

        setTimeout(() => {
          emit('payFinish')
        }, 500);
      }

      // 待支付
      if (orderStatus === 1 && !isInApp()) {
        if (duration >= 600000) {

          Toast('支付超时，请重新支付')

          clearInterval(timer.value);
          duration = 0;
          loading.value = false
        }
      }

    } else {
      clearInterval(timer.value)
      loading.value = false
    }
  }, 1000)
}

// 桥唤起小程序
function handleAppPay() {
  console.log('store.getters.getToken', store.getters.getToken)
  WebBridgeApi.launchWechatProgram({
    userName: 'gh_8ed642eec288',
    path: 'pages/index/index',
    miniProgramType: process.env.VUE_APP_ENV_VERSION === 'prod' ? 0 : 2,
    extDic: {
      orgid: store.getters.getOrgId,
      uid: store.getters.getUser.id,
      orderSn,
      token: store.getters.getToken,
      originSystemId: PAY_ORIGIN_SYSTEM_ID,
    },
    reply: (data) => {
      console.log('handleAppPay--------->', data)
      if (data.result === 'fail') {
        Toast('支付失败')
        loading.value = false
        clearInterval(timer.value)
      }
    },
  }).then(res => {
    console.log('res', res)
  })

  // 开始轮询
  pollOrderStatus()
}

// 微信网页支付
async function handleWechatH5Pay() {
  loading.value = true

  const redirectUrl = `${window.location.origin}/#/?questionActiveKey=${route.query.questionActiveKey}&orgid=${store.getters.getOrgId}&orderSn=${orderSn}`
  const okRedirectUrl = `${window.location.origin}/#/person/record?questionActiveKey=${route.query.questionActiveKey}&orgid=${store.getters.getOrgId}`

  try {
    const res = await payOrder({
      orderSn,
      systemId: PAY_ORIGIN_SYSTEM_ID,
      redirectUrl,
      okRedirectUrl,
      payWay: 'WeixinJsapiOL',
      token: store.getters.getToken
    })

    if (res.code === 1) {
      window.location.href = res.data.NonNativePaySkipLink
    } else {
      Toast(res.errmsg)
    }
  } catch (error) {

  } finally {
    loading.value = false
  }
}

// 处理唤起微信小程序
const handleJump2Wechat = () => {
  const query = {
    path: "pages/index/index",
    orgid: store.getters.getOrgId,
    uid: store.getters.getUser.id,
    token: store.getters.token,
    orderSn: route.query.orderSn,
    // 支付来源
    originSystemId: PAY_ORIGIN_SYSTEM_ID
  }

  // 小程序版本，正式版和体验版
  const envVersion = process.env.VUE_APP_ENV_VERSION === 'prod' ? 'release' : 'trial'

  Toast('请在微信浏览器中完成支付')

  // window.location.href =
  //   `weixin://dl/business/?appid=wx0b281f8fe75974b6&path=pages/index/index&env_version=${envVersion}&query=${encodeURIComponent(query)}`

}

function handlePayClick() {
  if (isInApp()) {
    handleAppPay()
  } else {
    // handleJump2Wechat()
    handleWechatH5Pay()
  }
}

function handleStartPay() {
  pollOrderStatus()
}

function handleFinished() {
  showWxMiniProgram.value = false
}

onMounted(() => {
  if (orderSn) {
    if (isWeixinBrowser()) {
      showWxMiniProgram.value = true
    }
  }
})

onUnmounted(() => {
  clearInterval(timer.value)
})
</script>
<template>
  <div class="pay-wrap">
    <img class="pay-logo" src="@/assets/img/pay/pay-logo.png" alt="">
    <p class="pay-tips">即将打开”金鲤客“</p>
    <p class="pay-tips">进行缴费</p>
    <div @click="handlePayClick" class="pay-btn">
      {{ loading ? '支付中...' : '立即支付' }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.pay-wrap {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  background: linear-gradient(to bottom right, #e7fff2, white 50%, white 50%, #cce5ff);
  z-index: 2;

  .pay-logo {
    margin-top: 16vh;
    width: 450px;
  }

  .pay-tips {
    margin-top: 15px;
    font-size: 34px;
    color: black;
  }

  .loading {
    margin-top: 240px;
    text-align: center;
  }

  .pay-btn {
    display: block !important;
    margin: 80px auto;
    width: 240px;
    height: 40px;
    text-align: center;
    font-size: 34px;
    font-weight: bold;
    padding: 16px 48px;
    border: none;
    border-radius: 50px;
    background-color: rgb(2, 236, 189);
    color: #fff;
  }
}
</style>
